import(/* webpackMode: "eager" */ "/var/www/appagent/src/app/forgot-password/page.tsx");
